import { cva } from "class-variance-authority";
import { cn, Slot } from "../../utils";
import { Text } from "../Typography";
import type { BadgeProps } from "./types";

const badgeVariants = cva(
  "absolute translate-x-1/2 rtl:-translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-lg p-1 cursor-default min-w-6 h-6 pointer-events-none",
  {
    variants: {
      color: {
        primary: "bg-primary-500 text-white",
        success: "bg-success-500 text-white",
        danger: "bg-danger-500 text-white",
        warning: "bg-warning-500 text-white",
        info: "bg-info-500 text-white",
      },
    },
    defaultVariants: {
      color: "primary",
    },
  },
);

export const Badge = (props: BadgeProps) => {
  const {
    children,
    content,
    className,
    color = "danger",
    hide = false,
    offset = 15,
    ...forwardedProps
  } = props;

  const offsetTop = typeof offset === "number" ? offset : offset.top;
  const offsetEnd = typeof offset === "number" ? offset : offset.end;

  const badgeStyle = {
    top: `${offsetTop}%`,
    insetInlineEnd: `${offsetEnd}%`,
  };

  const displayContent = content && content > 99 ? "99+" : content;
  const showContent = !hide && !!content;

  return (
    <div className={cn("relative inline-block", className)}>
      <Slot {...forwardedProps}>{children}</Slot>
      {showContent && (
        <div className={badgeVariants({ color })} style={badgeStyle}>
          <Text size="sm">{displayContent}</Text>
        </div>
      )}
    </div>
  );
};

export { badgeVariants };
